import { useState } from "react";
import { Content } from "./Content";
import { Heading } from "./Heading";
import { NavBar } from "./NavBar";
import { Profile } from "./Profile";

export function Display() {
  const [clicked, set] = useState(0);
  console.log(clicked == 0 ? "jkj" : "dfsf");
  return (
    <div className="container">
      <div>
        <Profile />
      </div>
      <div className="data">
      <div className="navdiv">
          <NavBar setter={set} />
        </div>
        <div className="inner">
          <Heading clicked={clicked} />
          <Content clicked={clicked} />
        </div>
      </div>
    </div>
  );
}
